import { Navigate, useOutletContext, useParams } from "react-router-dom";
import { Center, Stack, Text } from "@chakra-ui/react";

import { CSVUploadJobResponseStatusEnum } from "api";
import UploadBox from "components/UploadBox";
import { CsvStep, UploadProgressSpinner } from "components/CsvUpload";
import WithSpinner from "components/WithSpinner";
import useCsvUploadJob from "hooks/csv-upload/useCsvUploadJob";
import csvPaths from "routes/csv-uploads/csvPaths";

const ActualTonsResultsNoErrors = () => {
  const [, setFile] =
    useOutletContext<[File, (file: File | undefined) => void]>();
  const { jobId } = useParams();
  const { data, isPending } = useCsvUploadJob(jobId, (data) => {
    if (data?.status === CSVUploadJobResponseStatusEnum.Success) {
      setFile(undefined);
    }
  });

  const isComplete = data?.status === CSVUploadJobResponseStatusEnum.Success;
  if (isComplete && (data?.itemsWithErrors ?? 0) > 0) {
    return (
      <Navigate
        to={`../${csvPaths.children.actualTons.children.results}/${jobId}`}
      />
    );
  }

  return (
    <>
      <CsvStep currentStep={3} totalSteps={3} description="Upload Complete" />
      <WithSpinner isLoading={isPending}>
        <UploadBox h="unset" py="134px" bg="gray.50" borderColor="gray.200">
          <Center>
            <Stack alignItems="center">
              <UploadProgressSpinner isLoading={false} />
              <Text fontWeight="bold">
                {`${data?.itemsProcessedSuccessfully} out of ${data?.totalItems} successfully uploaded.`}
              </Text>
            </Stack>
          </Center>
        </UploadBox>
      </WithSpinner>
    </>
  );
};

export default ActualTonsResultsNoErrors;
